{
  "signup": {
    "preview": "BidNova Auctions アカウントを有効化するにはメールアドレスをご確認ください",
    "heading": "メールアドレスの確認",
    "body1": "BidNova Auctions へようこそ——英国屈指のグレーディング済みPokémonカード取引マーケットプレイスです。",
    "body2": "メールアドレス{recipientSuffix}を確認し、アカウントを有効化してGBPでの入札を開始してください。",
    "recipientSuffix": "（{recipient}）",
    "cta": "メールアドレスを確認する",
    "footer": "このリンクは一度限り有効で、まもなく期限切れとなります。アカウントを作成していない場合は、このメールを無視して問題ありません。",
    "subject": "メールアドレスを確認してください"
  },
  "recovery": {
    "preview": "BidNova Auctions のパスワードをリセットする",
    "heading": "パスワードのリセット",
    "body1": "BidNova Auctions アカウントのパスワードリセットのご依頼を受け付けました。下のボタンから新しいパスワードを設定してください。",
    "cta": "パスワードをリセット",
    "footer": "このリンクは一度限り有効で、まもなく期限切れとなります。パスワードのリセットを依頼していない場合は、このメールを無視して問題ありません。パスワードは変更されません。",
    "subject": "パスワードを再設定してください"
  },
  "magicLink": {
    "preview": "BidNova Auctions のログインリンク",
    "heading": "ログインリンク",
    "body": "下のボタンから BidNova Auctions にログインしてください。このリンクはまもなく期限切れとなります。",
    "cta": "ログイン",
    "footer": "このリンクをリクエストしていない場合は、このメールを無視して問題ありません。",
    "subject": "ログインリンク"
  },
  "emailChange": {
    "preview": "{siteName} のメールアドレス変更を確認する",
    "heading": "メールアドレス変更の確認",
    "body1": "{siteName} のメールアドレスを {oldEmail} から {newEmail} に変更するリクエストを受け付けました。",
    "body2": "下のボタンからこの変更を確認してください：",
    "cta": "メールアドレス変更を確認",
    "footer": "この変更に心当たりがない場合は、直ちにアカウントを保護してください。",
    "subject": "新しいメールアドレスの確認"
  },
  "reauthentication": {
    "preview": "認証コード",
    "heading": "再認証の確認",
    "body": "本人確認のため、以下のコードを使用してください：",
    "footer": "このコードはまもなく期限切れとなります。心当たりがない場合は、このメールを無視して問題ありません。",
    "subject": "認証コード"
  },
  "invite": {
    "preview": "{siteName} への招待が届いています",
    "heading": "招待が届いています",
    "body": "{siteName} への招待が届いています。下のボタンから招待を承諾し、アカウントを作成してください。",
    "cta": "招待を承諾する",
    "footer": "心当たりのない招待の場合は、このメールを無視して問題ありません。",
    "subject": "招待が届いています"
  },
  "newBidReceived": {
    "preview": "{auctionTitle} に新しい入札がありました",
    "previewFallback": "あなたのオークションに新しい入札がありました",
    "heading": "新しい入札がありました",
    "bidderFallback": "あるコレクター",
    "auctionFallback": "あなたの出品",
    "body": "{bidder}が {auctionTitle} に入札しました。",
    "keyValueLabel": "現在の最高入札額",
    "bodyWatch": "オークションをリアルタイムで確認し、終了までの動向を見守りましょう。",
    "cta": "オークションを見る",
    "subject": "{auctionTitle} に新しい入札",
    "subjectFallback": "新しい入札があります"
  },
  "outbid": {
    "preview": "他の入札者に追い抜かれました",
    "heading": "他の入札者に追い抜かれました",
    "auctionFallback": "あるオークション",
    "body": "{auctionTitle} により高い入札がありました。",
    "keyValueLabel": "現在の最高入札額",
    "bodyJump": "終了時間が来る前に、再度入札しましょう。",
    "cta": "より高い金額で入札する",
    "subject": "{auctionTitle} で入札を上回られました"
  },
  "auctionWon": {
    "preview": "落札おめでとうございます！お支払いを完了してください。",
    "heading": "落札しました 🏆",
    "auctionFallback": "オークション",
    "body1": "おめでとうございます——{auctionTitle} を落札しました。",
    "body2": "48時間以内にお支払いを完了し、注文を確定して発送手続きを進めてください。",
    "cta": "今すぐ支払う",
    "subject": "{auctionTitle} を落札しました——お支払いが必要です"
  },
  "auctionLost": {
    "preview": "オークションが終了しました",
    "heading": "オークションが終了しました",
    "auctionFallback": "オークション",
    "auctionFallbackShort": "あるオークション",
    "bodyDefault": "残念ながら、{auctionTitle} でのあなたの入札は落札に至りませんでした。",
    "bodyMore": "他にも魅力的なグレーディング済みカードが続々登場しています——ぜひご覧ください。",
    "cta": "開催中のオークションを見る",
    "subject": "オークション終了：{auctionTitle}"
  },
  "auctionEndingSoon": {
    "preview": "ウォッチ中のオークションがまもなく終了します",
    "heading": "まもなく終了",
    "auctionFallback": "オークション",
    "endsInFallback": "1時間",
    "body": "{auctionTitle} は{endsIn}後に終了します。",
    "keyValueLabel": "現在の最高入札額",
    "cta": "入札する",
    "subject": "まもなく終了：{auctionTitle}"
  },
  "orderCreated": {
    "preview": "購入者の支払いをお待ちください",
    "heading": "注文が作成されました",
    "auctionFallback": "出品",
    "bodyWithAmount": "あなたのオークション {auctionTitle} が終了し、落札金額は {amount} でした。",
    "bodyNoAmount": "あなたのオークション {auctionTitle} が落札されました。",
    "body2": "購入者が支払いを完了次第、改めてご連絡いたします。その後、発送手続きを行い、発送済みとしてマークできます。",
    "cta": "ダッシュボードを開く",
    "subject": "{auctionTitle} の注文が作成されました"
  },
  "orderPaid": {
    "preview": "支払いが確認されました",
    "heading": "支払いが確認されました",
    "orderFallback": "ご注文",
    "bodyWithAmount": "{auctionTitle} に対する {amount} のお支払いが確認されました。",
    "bodyNoAmount": "{auctionTitle} に対するお支払いが確認されました。",
    "body2": "出品者に通知済みで、まもなく発送されます。追跡番号が発行され次第、改めてメールにてお知らせします。",
    "body3WithNumber": "領収書（{invoiceNumber}）を添付しております。注文ページからもいつでもご確認いただけます。",
    "body3NoNumber": "領収書を添付しております。注文ページからもいつでもご確認いただけます。",
    "ctaReceipt": "領収書をダウンロード（PDF）",
    "ctaOrder": "注文を見る",
    "subject": "{auctionTitle} の支払いが確認されました"
  },
  "orderCompleted": {
    "preview": "注文が完了しました——{auctionTitle}",
    "heading": "注文完了",
    "cardFallback": "このカード",
    "bodySeller": "{auctionTitle} のご注文が完全に完了しました。売上金は既にお振込済みで、購入者からの評価も届いています。",
    "bodyBuyer": "{auctionTitle} のご注文が完全に完了しました。出品者への支払いも完了し、取引は終了しました。",
    "keyValueLabel": "注文合計金額",
    "body2": "BidNova Auctions をご利用いただきありがとうございます。他のコレクターや出品者のためにレビューをお願いします。",
    "cta": "注文を見る",
    "subjectWithTitle": "注文完了——{auctionTitle}",
    "subjectFallback": "ご注文が完了しました"
  },
  "paymentReceivedSeller": {
    "preview": "支払いを受け取りました——発送してください",
    "heading": "支払いを受け取りました",
    "listingFallback": "あなたの出品",
    "bodyWithAmount": "朗報です——購入者が {auctionTitle} に対して {amount} を支払いました。",
    "bodyNoAmount": "朗報です——購入者が {auctionTitle} の支払いを完了しました。",
    "body2": "3営業日以内に発送し、追跡番号を入力して発送済みにしてください。",
    "body3WithNumber": "販売用インボイス（{invoiceNumber}）をご用意しております。出品者ダッシュボードからもご確認いただけます。",
    "body3NoNumber": "販売用インボイスをご用意しております。出品者ダッシュボードからもご確認いただけます。",
    "ctaInvoice": "インボイスをダウンロード（PDF）",
    "ctaDashboard": "出品者ダッシュボードを開く",
    "subject": "{auctionTitle} の支払いを受け取りました——発送をお願いします"
  },
  "itemShipped": {
    "preview": "ご注文の商品が発送されました",
    "heading": "商品を発送しました",
    "cardFallback": "お客様のカード",
    "body1": "{auctionTitle} が出品者より発送されました。",
    "keyValueLabel": "追跡番号",
    "body2": "商品到着後は、出品者への支払いを行うため注文ページから受け取り確認をお願いします。",
    "cta": "注文を見る",
    "subject": "発送済み：{auctionTitle}",
    "orderFallback": "ご注文"
  },
  "trackingAvailable": {
    "preview": "Royal Mail の追跡番号が発行されました",
    "heading": "追跡番号が発行されました",
    "orderFallback": "ご注文",
    "carrierFallback": "Royal Mail",
    "body1": "{auctionTitle} の配送ラベルが発行されました。出品者がまもなく {carrier} に発送手続きを行います。",
    "keyValueLabel": "追跡番号",
    "cta": "配送状況を追跡する",
    "footer": "注文内容と追跡状況は {ordersUrl} からいつでもご確認いただけます。",
    "subject": "{auctionTitle} の追跡番号"
  },
  "deliveryConfirmed": {
    "preview": "購入者が受け取りを確認しました",
    "heading": "受け取りが確認されました",
    "cardFallback": "このカード",
    "saleFallback": "この販売",
    "body1": "購入者が {auctionTitle} の受け取りを確認しました。",
    "body2": "プラットフォーム手数料8%を差し引いた売上金は、まもなく担当チームより振り込まれます。",
    "cta": "ダッシュボードを開く",
    "subject": "{auctionTitle} の受け取りが確認されました"
  },
  "sellerPayout": {
    "preview": "売上金が振り込まれました",
    "heading": "売上金の振込完了",
    "saleFallback": "この販売",
    "bodyWithAmount": "{auctionTitle} に対する {amount} の売上金が Stripe アカウントへ振り込まれました。",
    "bodyNoAmount": "{auctionTitle} に対する売上金が Stripe アカウントへ振り込まれました。",
    "keyValueLabel": "振込参照番号",
    "footer": "通常1〜2営業日以内にご入金が確認できます。",
    "cta": "ダッシュボードを開く",
    "subject": "{auctionTitle} の売上金が振り込まれました"
  },
  "refundCompleted": {
    "heading": "返金が完了しました",
    "bodySeller": "ご注文の1件について返金が完了しました。",
    "bodyBuyer": "返金が完了しました。まもなくご利用のお支払い方法に反映されます。",
    "itemLabel": "商品",
    "amountLabel": "金額",
    "cta": "注文を見る",
    "subject": "返金が完了しました"
  },
  "listingApproved": {
    "preview": "出品が公開されました",
    "heading": "出品が承認されました",
    "listingFallback": "あなたの出品",
    "body": "{auctionTitle} が承認され、BidNova に公開されました。",
    "cta": "出品を見る",
    "subject": "出品承認：{auctionTitle}",
    "itemFallback": "商品"
  },
  "listingRejected": {
    "preview": "出品内容の修正が必要です",
    "heading": "出品内容の修正が必要です",
    "body": "ご提出いただいた出品 {auctionTitle} は、現状のままでは承認できませんでした。",
    "reasonLabel": "理由",
    "body2": "出品者ダッシュボードから内容を編集し、再度提出できます。",
    "cta": "出品を編集する",
    "subject": "出品の修正が必要です：{auctionTitle}",
    "itemFallback": "商品"
  },
  "welcome": {
    "preview": "BidNova Auctions へようこそ",
    "headingWithName": "ようこそ、{displayName} さん！",
    "headingPlain": "ようこそ！",
    "body1": "BidNova Auctions にご登録いただきありがとうございます——英国屈指のグレーディング済みPokémonカード取引マーケットプレイスです。",
    "body2": "開催中のオークションを閲覧し、GBPで入札してお探しの逸品を手に入れましょう。",
    "cta": "開催中のオークションを見る",
    "footer": "出品もご希望の方は、ダッシュボードで Stripe 認証を完了し、最初のカードを出品しましょう。",
    "subject": "BidNova Auctions へようこそ"
  },
  "disputeNotification": {
    "headlineDefault": "異議申立ての更新",
    "introDefault": "ご注文に関連する異議申立てに更新があります。",
    "orderLabel": "注文",
    "itemLabel": "商品",
    "statusLabel": "異議申立ての状況",
    "actionRequiredLabel": "必要な対応",
    "notAvailable": "—",
    "cta": "異議申立てを見る",
    "footer": "このメールは、あなたが本件の異議申立ての当事者であるため送信されています。詳細情報、メッセージ、証拠は常にディスピュートセンターでご確認いただけます。",
    "subjectDefault": "異議申立ての更新"
  },
  "watchlistNewBid": {
    "preview": "ウォッチ中のオークションに新しい入札がありました",
    "heading": "ウォッチ中のオークションに新しい入札",
    "auctionFallback": "ウォッチ中のオークション",
    "body": "{auctionTitle} に新しい入札がありました。",
    "keyValueLabel": "現在の最高入札額",
    "cta": "オークションを見る",
    "subject": "{auctionTitle} に新しい入札",
    "subjectFallback": "ウォッチ中のオークション"
  },
  "auctionBelowReserve": {
    "preview": "オークションが最低落札価格に届きませんでした",
    "heading": "最低落札価格に届かず終了しました",
    "auctionFallback": "あなたのオークション",
    "body": "出品 {auctionTitle} は終了しましたが、最低落札価格に届かなかったため取引は成立しませんでした。",
    "highestBidLabel": "最高入札額",
    "reserveLabel": "最低落札価格",
    "body2": "出品者ダッシュボードからいつでも再出品いただけます。",
    "cta": "再出品する",
    "subject": "{auctionTitle} は最低落札価格に届きませんでした"
  },
  "paymentReminder": {
    "preview": "落札分のお支払いに関するリマインダー",
    "heading": "お支払いリマインダー",
    "orderFallback": "ご注文",
    "bodyWithAmount": "{auctionTitle}（{amount}）のお支払いがまだ完了していません。",
    "bodyNoAmount": "{auctionTitle} のお支払いがまだ完了していません。",
    "body2": "未払いのご注文はキャンセルされ、次点の入札者に権利が移る場合があります。",
    "cta": "今すぐ支払う",
    "subject": "リマインダー：{auctionTitle} のお支払いをお願いします"
  },
  "adminAlert": {
    "subjectFallback": "プラットフォームアラート",
    "body": "BidNova Auctions で対応が必要なイベントが発生しました。",
    "cta": "管理ダッシュボードを開く",
    "subjectPrefix": "[BidNova Auctions] {subject}"
  }
}